import { GET_STORE_CONFIG } from '@/graphql/queries/getStoreConfig.gql.js';
import { useQuery } from '@apollo/client';

const CHILD_OVERRIDE_ATTRS = ['lw_shaft_height', 'lw_calf_circumference', 'product_dimensions'];

const ShowAttributes = props => {
  const { attributes, childAttributes } = props;
  const { data } = useQuery(GET_STORE_CONFIG);
  const weightUnit = data?.storeConfig?.weight_unit || 'kgs';

  const renderAttributes = (() => {
    const attributeMap = Array.isArray(attributes)
      ? attributes.reduce((acc, cur) => {
          if (!cur) return acc;
          acc[cur.code] = cur;
          return acc;
        }, {})
      : {};

    if (Array.isArray(childAttributes)) {
      childAttributes.forEach(attr => {
        if (attr && CHILD_OVERRIDE_ATTRS.includes(attr.code)) {
          attributeMap[attr.code] = attr;
        }
      });
    }

    const shaftHeightVal = attributeMap['lw_shaft_height']?.value;
    const hasShaftHeight = shaftHeightVal && !isNaN(parseFloat(shaftHeightVal));

    return ATTRIBUTES.reduce((acc, cur) => {
      let attribute = attributeMap[cur];

      if (!attribute || !attribute.value) return acc;

      if (cur === 'lw_boot_height' && hasShaftHeight) return acc;

      if (attribute.code === 'weight') {
        let val = parseFloat(attribute.value);
        if (!isNaN(val)) {
          if (weightUnit === 'lbs') {
            val = val * 2.20462262;
          }
          attribute = {
            ...attribute,
            value: `${val.toFixed(2)} lbs`,
          };
        }
      }

      acc.push(attribute);
      return acc;
    }, []);
  })();

  if (renderAttributes.length === 0) {
    return null;
  }

  return (
    <div>
      <h2 className='font-roboto-medium text-lg font-medium leading-[21px]'>Specs:</h2>
      <table className='mt-2.5 w-full '>
        <tbody>
          {renderAttributes.map(({ label, value, code }) => {
            return (
              <tr key={code}>
                <td className='h-10 min-w-[120px] border-collapse whitespace-pre-wrap border-1 border-solid  border-e0e0e0 bg-f9f9f9  text-center font-roboto-medium text-[16px] font-medium lg_min-w-[160px]'>
                  {label}
                </td>
                <td className='h-10 w-full border-collapse whitespace-pre-wrap border-1 border-solid border-e0e0e0 text-center font-roboto-light text-[16px] font-light lg_text-[14px]'>
                  {value}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const ATTRIBUTES = [
  'weight',
  'product_dimensions',
  'lw_heel_height',
  'lw_boot_height',
  'lw_shaft_height',
  'lw_calf_circumference',
  'lw_material',
  'lw_material_clothing',
  'lw_calf_width',
  'insulation',
  'lw_water_resistance',
];

export default ShowAttributes;
